export class Alcada {
  public id!: number | string | null;
  public nomeAlcada!: string;
  public tipoAcesso!: string;
  public valorAlcada!: number;
  public faseAlcada!: string;

  public aprova!: boolean;
  public reprova!: boolean;
  public altera!: boolean;
  public pendencia!: boolean;
}